<template>
  <mdb-btn-group vertical>
    <mdb-btn
      color="blue"
      size="sm"
      v-if="buttonAmount > 0"
      v-on:click="buttonPressed(1)"
    >
      {{ this.params.buttons[0] }}
    </mdb-btn>
    <mdb-btn
      color="blue"
      size="sm"
      v-if="buttonAmount > 1"
      v-on:click="buttonPressed(2)"
    >
      {{ this.params.buttons[1] }}
    </mdb-btn>
    <mdb-btn
      color="blue"
      size="sm"
      v-if="buttonAmount > 2"
      v-on:click="buttonPressed(3)"
    >
      {{ this.params.buttons[2] }}
    </mdb-btn>
  </mdb-btn-group>
</template>

<script>
import { mdbBtn, mdbBtnGroup } from "mdbvue";

export default {
  name: "SimpleButtonGroup",
  components: {
    mdbBtn,
    mdbBtnGroup,
  },
  props: {},
  mounted() {
    this.buttonAmount = this.params.buttons.length;
  },
  data: () => ({
    buttonAmount: 0,
  }),
  methods: {
    buttonPressed(button) {
      this.params.clicked(this.params.data.id, button);
    },
  },
};
</script>
